export default __webpack_public_path__ + "static/media/logo_farplus.1ca057fa.png";